const swapElements = (array, index1, index2) => {
  const copy = [...array];

  [copy[index1], copy[index2]] = [copy[index2], copy[index1]];

  return copy;
};

export default swapElements;
